import React from 'react';
import clsx from 'clsx';
import * as styles from '../../styles/containers/DashboardEditor.less';
import { withTranslation, WithTranslation } from 'react-i18next';
import SuperuserIsActive from '../../containers/SuperuserIsActive';
import ConfirmationDialog from '../common/ConfirmationDialog';

interface DashboardActionsOwnProps {
  isLoading: boolean;
  isDashboardValid: boolean;
  // dashboard.disabled — the Delete button is only shown for a disabled dashboard.
  disabled: boolean;
  showDialog: boolean;
  name: string;
  onSave: () => void;
  onDeleteClick: () => void;
  onDeleteConfirm: () => void;
  onDeleteCancel: () => void;
}

// The Save / Delete button row plus the delete ConfirmationDialog. Delete (and
// its dialog) are superuser-only and only visible once the dashboard is disabled.
const DashboardActions = ({
  isLoading, isDashboardValid, disabled, showDialog, name,
  onSave, onDeleteClick, onDeleteConfirm, onDeleteCancel, t,
}: DashboardActionsOwnProps & WithTranslation) => (
  <div style={{ display: "flex" }}>
    <button className={clsx(isLoading ? styles.hidden : styles.save, 'button success')}
      onClick={onSave}
      disabled={!isDashboardValid}
      >{t('button.save')}</button>
    <SuperuserIsActive>
      <button className={clsx(isLoading || !disabled ? styles.hidden : styles['delete-button'], 'button alert')}
        onClick={onDeleteClick}
        >{t('button.delete')}</button>

      {showDialog && (
        <ConfirmationDialog
          message={t('dashboard.editor.confirmDelete') + name + "?"}
          confirmText={t('button.yes')}
          cancelText={t('button.no')}
          onConfirm={onDeleteConfirm}
          onCancel={onDeleteCancel}
        />
      )}
    </SuperuserIsActive>
  </div>
);

export default withTranslation('common')(DashboardActions);
